import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import websocketHandler from "./libs/websocketHandler";

const state = {
  token: null,
  user_id:null,
  fullName: null,
  menus: null,
  menuToggle: "toggled",
  menuActiveId: 1,
  userGroupType: "registered",
  cartCount: 0,
  cartAmount: 0,
  pathAfterLogin: null,
  socket: {
    isConnected: false,
    message: "",
    reconnectError: false,
  },
  uploadPercentage:0
};

let wsHandler = null;

const mutations = {
  set(state, [variable, value]) {
    state[variable] = value;
  },
  unset(state, variable) {
    delete state[variable];
  },
  disconnectSocket(){
    if(wsHandler){
      wsHandler.close();
    }
  },
  SOCKET_ONOPEN(state, event) {
    this.$socket = event.currentTarget;
    if (state.socket) {
      wsHandler = new websocketHandler(event.currentTarget, state);
      state.socket.isConnected = true;
      state.socket.reconnectError = false;
    }
  },
  SOCKET_ONCLOSE(state) {
    if (state.socket) {
      state.socket.isConnected = false;
    }
  },
  SOCKET_ONERROR(state) {
    //console.error(state, event);
    state.socket.isConnected = false;
  },
  // default handler called for all methods
  SOCKET_ONMESSAGE(state, message) {
    if (state.socket) {
      state.socket.message = message;
      wsHandler.onMessageReceived(message);
    }
  },
  // mutations for reconnect methods
  // SOCKET_RECONNECT(state, count) {
  //   console.info(state, count);
  // },
  SOCKET_RECONNECT() {
    //console.info("SOCKET_RECONNECT",state, count);
  },
  SOCKET_RECONNECT_ERROR(state) {
    state.socket.reconnectError = true;
    const wsHandler = new websocketHandler();
    wsHandler.onReconnectError();
  },
};

export default new Vuex.createStore({
  plugins: [createPersistedState()],
  state,
  mutations,
});
